import React, { useState, useEffect, useRef } from "react";
import { CircularProgress } from "@mui/material";
import dayjs from "dayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import DateConverter from "@heartinz/date_and_time_processor";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import priceCalculator from "@heartinz/gst_india_product_price_calculator";
import finance, {
  toPrimaryQuantity,
  toPrimaryUnitPrice,
  toSecondaryQuantity,
  toSecondaryUnitPrice,
  getAllPriceList,
} from "@heartinz/finance";

import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import handleError from "../../../constants/handleError";
import Messages from "../../../constants/Messages";
import { useAuth } from "../../../context/AuthProvider";
import GetServerLiveTime from "../../../constants/GetServerLiveTime";
import { usePermission } from "../../../context/PermissionContext";
import { useLocation } from "react-router-dom";
import uRLs from "../../../utils/baseUtils";
import { handleUnitNameSelect } from "../../../utils/unitUtils";
import { LineDoubleIcon, StockAddIcon, XIcon } from "../../../constants/Icons";

const AddStockModel = ({
  onclose,
  onData,
  stockData,
  onUpdate,
  onStockAdd,
  isBtnLoading,
  onStockCreate,
  finalLand,
}) => {
  const location = useLocation();
  const [error, setErrors] = useState("");
  // const [isSelectedRadio, setSelectedRadio] = useState("SALEPRICE");
  const [toggles, setToggles] = useState({ stock: true });
  const [loading, setLoading] = useState({ stock: false });
  const { checkNetwork } = useNetwork();
  const { isUser, settings } = useAuth();
  const serverTime = GetServerLiveTime();
  const showAlert = useShowAlert();
  const { permission, viewOption, blockedPermissions } = usePermission();
  const { data } = location?.state || {};
  const searchRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [selectedUnit, setSelectedUnit] = useState();
  const productMrpRef = useRef(null);
  const productSalepriceRef = useRef(null);
  const productTaxpercentageRef = useRef(null);
  const productBasepriceRef = useRef(null);
  const productMdateRef = useRef(null);
  const productMultiCostRef = useRef(null);
  const productLandingCostRef = useRef(null);
  const manufacturedateRefs = useRef(null);
  const expiredateRefs = useRef(null);
  const addStockBtnRef = useRef(null);
  const [unitData, setUnitData] = useState();
  const popupMrpInputRef = useRef(null);
  const [showMrpPopup, setShowMrpPopup] = useState(false);
  const [popupMrpValue, setPopupMrpValue] = useState("");
  const [popupMrpStyle, setPopupMrpStyle] = useState({});
  const [selectedProduct, setselectedProduct] = useState(null);
  const [isProductData, setProductData] = useState({
    code: "",
    hsnsac: "",
    title: "",
    note: "",
    mrp: 0,
    saleprice: 0,
    taxpercentage: 0,
    discount: 0,
    baseprice: 0,
    taxamount: 0,
    quantity: 0,
    landingcost: 0,
    lcmultiplayer: 0,
    finalLandingCost: 0,
    isLock: "SALEPRICE",
  });
  const [isApiData, setApiData] = useState({
    code: "",
    hsnsac: "",
    title: "",
    note: "",
    mrp: 0,
    quantity: 0,
    saleprice: 0,
    taxpercentage: 0,
    discount: 0,
    baseprice: 0,
    taxamount: 0,
    landingcost: 0,
    isLock: "SALEPRICE",
    primaryUnit: "",
    secondaryUnit: "",
    conversionValue: 0,
  });
  const baseRef = useRef({
    mrp: 0,
    saleprice: 0,
    baseprice: 0,
  });
  const handleUnitName = (unitData) => {
    handleUnitNameSelect(unitData, settings);
  };

  const defaultConversion = settings?.defaultUnits?.find(
    (u) => u?.unitCode === isProductData?.totalStockLeftUnit,
  );
  const iso = serverTime.toISOString();
  const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);

  const [manufacturedate, setMDate] = useState("");
  const [expiredate, setEDate] = useState("");
  const [expireMinDate, setExpireMinDate] = useState(iso);
  const [openMfgDate, setOpenMfgDate] = useState(false);
  const [openExpDate, setOpenExpDate] = useState(false);
  const mfgDateWrapperRef = useRef(null);
  const expDateWrapperRef = useRef(null);
  const [openPicker, setOpenPicker] = useState(null);

  const isSecondaryUnit = () => {
    if (isProductData.unitConfig?.primaryUnitCode === selectedUnit) {
      return false;
    } else if (isProductData.unitConfig?.secondaryUnitCode === selectedUnit) {
      return true;
    } else {
      return false;
    }
  };

  const handleMDateChange = ([selectedDate]) => {
    const iso = selectedDate.toISOString();
    const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);
    setMDate(indiaTime);
    setExpireMinDate(indiaTime);
  };

  const handleEDateChange = ([selectedDate]) => {
    const iso = selectedDate.toISOString();
    const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);
    setEDate(indiaTime);
  };

  const handleToggleChange = (key) => {
    setToggles((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  const handleSelectSuggestion = async (product, finalLand) => {
    try {
      const fullProduct = product;

      setselectedProduct(fullProduct);
      setProductData({
        ...fullProduct,
        mrp: CurrencyConverter.toCurrency(fullProduct.mrp || 0, "INR"),
        saleprice: CurrencyConverter.toCurrency(
          fullProduct.saleprice || 0,
          "INR",
        ),
        taxpercentage: fullProduct.taxpercentage,
        discount: CurrencyConverter.toCurrency(
          fullProduct.discount || 0,
          "INR",
        ),
        baseprice: CurrencyConverter.toCurrency(
          fullProduct.baseprice || 0,
          "INR",
        ),
        taxamount: CurrencyConverter.toCurrency(
          fullProduct.taxamount || 0,
          "INR",
        ),
        quantity: 0,
        isLock: fullProduct.isLock,
        isStock: fullProduct.isStock,
        landingcost: CurrencyConverter.toCurrency(
          fullProduct.landingcost || 0,
          "INR",
        ),
        lcmultiplayer: 0,
        finalLandingCost: CurrencyConverter.toCurrency(finalLand || 0, "INR"),
      });
      setApiData({
        mrp: fullProduct.mrp,
        saleprice: fullProduct.saleprice,
        baseprice: fullProduct.baseprice,
      });
      baseRef.current = {
        mrp: fullProduct.mrp / 100,
        saleprice: fullProduct.saleprice / 100,
        baseprice: fullProduct.baseprice / 100,
      };
      if (fullProduct?.unitConfig) {
        const name = handleUnitName(fullProduct?.unitConfig);
        setUnitData({
          ...fullProduct?.unitConfig,
          primaryUnitName: name?.primaryUnitName,
          secondaryUnitName: name?.secondaryUnitName,
        });
      } else {
        setUnitData();
      }
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleCalculate = (updatedData) => {
    var { mrp, saleprice, baseprice, taxpercentage } = updatedData;
    baseRef.current = {
      mrp,
      saleprice,
      baseprice,
    };
    // let numericMrp = CurrencyConverter.toSubunit(mrp || 0, "INR");
    // let numericSaleprice = CurrencyConverter.toSubunit(saleprice || 0, "INR");
    // let numericBaseprice = CurrencyConverter.toSubunit(baseprice || 0, "INR");
    let numericMrp = CurrencyConverter.toSubunit(
      baseRef.current.mrp || 0,
      "INR",
    );
    let numericSaleprice = CurrencyConverter.toSubunit(
      baseRef.current.saleprice || 0,
      "INR",
    );
    let numericBaseprice = CurrencyConverter.toSubunit(
      baseRef.current.baseprice || 0,
      "INR",
    );
    let numericTaxpercentage = parseInt(taxpercentage);
    let quanity = parseInt(1);
    let calculationResult;
    let lock = isProductData.isLock;
    try {
      calculationResult = getAllPriceList(
        numericMrp,
        numericSaleprice,
        numericBaseprice,
        numericTaxpercentage,
        quanity,
        lock,
      );

      if (lock === "SALEPRICE") {
        if (numericMrp !== calculationResult.mrp) {
          setProductData((prevData) => ({
            ...prevData,
            mrp: CurrencyConverter.toCurrency(calculationResult.mrp, "INR"),
            discount: CurrencyConverter.toCurrency(
              calculationResult.discount,
              "INR",
            ),
            taxamount: CurrencyConverter.toCurrency(
              calculationResult.gstAmount,
              "INR",
            ),
            baseprice: CurrencyConverter.toCurrency(
              calculationResult.basePrice,
              "INR",
            ),
          }));
          baseRef.current = {
            mrp: calculationResult.mrp / 100,
            saleprice: calculationResult.salePrice / 100,
            baseprice: calculationResult.basePrice / 100,
          };
          if (!isProductData.unitConfig) {
            // no unit → normal
            setApiData((prevData) => ({
              ...prevData,
              mrp: calculationResult.mrp,
              discount: calculationResult.discount,
              taxamount: calculationResult.gstAmount,
              baseprice: calculationResult.basePrice,
              saleprice: calculationResult.salePrice,
            }));
          } else {
            let primary;

            if (selectedUnit === isProductData?.unitConfig?.secondaryUnitCode) {
              const converted = toPrimaryUnitPrice(
                calculationResult.mrp,
                calculationResult.salePrice,
                calculationResult.basePrice,
                numericTaxpercentage,
                1,
                lock,
                isProductData?.unitConfig,
              );

              primary = converted;
            } else {
              primary = {
                primaryUnitPrice: calculationResult,
              };
            }
            setApiData((prevData) => ({
              ...prevData,
              mrp: primary?.primaryUnitPrice?.mrp,
              discount: primary?.primaryUnitPrice?.discount,
              taxamount: primary?.primaryUnitPrice?.taxAmount,
              baseprice: primary?.primaryUnitPrice?.basePrice,
              saleprice: primary?.primaryUnitPrice?.salePrice,
            }));
          }
        }
        setProductData((prevData) => ({
          ...prevData,
          discount: CurrencyConverter.toCurrency(
            calculationResult.discount,
            "INR",
          ),
          taxamount: CurrencyConverter.toCurrency(
            calculationResult.gstAmount,
            "INR",
          ),
          baseprice: CurrencyConverter.toCurrency(
            calculationResult.basePrice,
            "INR",
          ),
        }));
        baseRef.current = {
          mrp: calculationResult.mrp / 100,
          saleprice: calculationResult.salePrice / 100,
          baseprice: calculationResult.basePrice / 100,
        };
        if (!isProductData?.unitConfig) {
          // no unit → normal
          setApiData((prevData) => ({
            ...prevData,
            mrp: calculationResult.mrp,
            discount: calculationResult.discount,
            taxamount: calculationResult.gstAmount,
            baseprice: calculationResult.basePrice,
            saleprice: calculationResult.salePrice,
          }));
        } else {
          let primary;

          if (selectedUnit === isProductData?.unitConfig?.secondaryUnitCode) {
            const converted = toPrimaryUnitPrice(
              calculationResult.mrp,
              calculationResult.salePrice,
              calculationResult.basePrice,
              numericTaxpercentage,
              1,
              lock,
              isProductData?.unitConfig,
            );

            primary = converted;
          } else {
            primary = {
              primaryUnitPrice: calculationResult,
            };
          }

          setApiData((prevData) => ({
            ...prevData,
            mrp: primary?.primaryUnitPrice?.mrp,
            discount: primary?.primaryUnitPrice?.discount,
            taxamount: primary?.primaryUnitPrice?.taxAmount,
            baseprice: primary?.primaryUnitPrice?.basePrice,
            saleprice: primary?.primaryUnitPrice?.salePrice,
          }));
        }
      } else if (lock === "BASEPRICE") {
        if (numericMrp !== calculationResult.mrp) {
          setProductData((prevData) => ({
            ...prevData,
            mrp: CurrencyConverter.toCurrency(calculationResult.mrp, "INR"),
            discount: CurrencyConverter.toCurrency(
              calculationResult.discount,
              "INR",
            ),
            taxamount: CurrencyConverter.toCurrency(
              calculationResult.gstAmount,
              "INR",
            ),
            saleprice: CurrencyConverter.toCurrency(
              calculationResult.salePrice,
              "INR",
            ),
          }));
          baseRef.current = {
            mrp: calculationResult.mrp / 100,
            saleprice: calculationResult.salePrice / 100,
            baseprice: calculationResult.basePrice / 100,
          };
          if (!isProductData?.unitConfig) {
            // no unit → normal
            setApiData((prevData) => ({
              ...prevData,
              mrp: calculationResult.mrp,
              discount: calculationResult.discount,
              taxamount: calculationResult.gstAmount,
              baseprice: calculationResult.basePrice,
              saleprice: calculationResult.salePrice,
            }));
          } else {
            let primary;

            if (selectedUnit === isProductData?.unitConfig?.secondaryUnitCode) {
              const converted = toPrimaryUnitPrice(
                calculationResult.mrp,
                calculationResult.salePrice,
                calculationResult.basePrice,
                numericTaxpercentage,
                1,
                lock,
                isProductData?.unitConfig,
              );

              primary = converted;
            } else {
              primary = {
                primaryUnitPrice: calculationResult,
              };
            }

            setApiData((prevData) => ({
              ...prevData,
              mrp: primary?.primaryUnitPrice?.mrp,
              discount: primary?.primaryUnitPrice?.discount,
              taxamount: primary?.primaryUnitPrice?.taxAmount,
              baseprice: primary?.primaryUnitPrice?.basePrice,
              saleprice: primary?.primaryUnitPrice?.salePrice,
            }));
          }
        }
        setProductData((prevData) => ({
          ...prevData,
          discount: CurrencyConverter.toCurrency(
            calculationResult.discount,
            "INR",
          ),
          taxamount: CurrencyConverter.toCurrency(
            calculationResult.gstAmount,
            "INR",
          ),
          saleprice: CurrencyConverter.toCurrency(
            calculationResult.salePrice,
            "INR",
          ),
        }));
        baseRef.current = {
          mrp: calculationResult.mrp / 100,
          saleprice: calculationResult.salePrice / 100,
          baseprice: calculationResult.basePrice / 100,
        };
        if (!isProductData?.unitConfig) {
          // no unit → normal
          setApiData((prevData) => ({
            ...prevData,
            mrp: calculationResult.mrp,
            discount: calculationResult.discount,
            taxamount: calculationResult.gstAmount,
            baseprice: calculationResult.basePrice,
            saleprice: calculationResult.salePrice,
          }));
        } else {
          let primary;

          if (selectedUnit === isProductData?.unitConfig?.secondaryUnitCode) {
            const converted = toPrimaryUnitPrice(
              calculationResult.mrp,
              calculationResult.salePrice,
              calculationResult.basePrice,
              numericTaxpercentage,
              1,
              lock,
              isProductData?.unitConfig,
            );

            primary = converted;
          } else {
            primary = {
              primaryUnitPrice: calculationResult,
            };
          }

          setApiData((prevData) => ({
            ...prevData,
            mrp: primary?.primaryUnitPrice?.mrp,
            discount: primary?.primaryUnitPrice?.discount,
            taxamount: primary?.primaryUnitPrice?.taxAmount,
            baseprice: primary?.primaryUnitPrice?.basePrice,
            saleprice: primary?.primaryUnitPrice?.salePrice,
          }));
        }
      }
    } catch (error) {
      showAlert("warning", error.message || Messages.ERROR.INVALID_INPUT);
    }
  };

  const handleChange = (e) => {
    setErrors("");
    const { name, value } = e.target;
    let inputValue = value;

    if (
      name === "mrp" ||
      name === "saleprice" ||
      name === "baseprice" ||
      name === "landingcost"
    ) {
      const regex = /^$|^\d*\.?\d{0,2}$/;
      if (!regex.test(value)) {
        return;
      }
      inputValue = value;
    }

    if (name === "taxpercentage") {
      const allowedValues = [0, 5, 12, 18, 24];
      if (!allowedValues.includes(Number(value))) inputValue = 0;
    }

    if (["quantity"].includes(name)) {
      if (uRLs?.UNIT === "true" && isProductData?.unitConfig) {
        // allow decimal with max 3 digits
        if (isSecondaryUnit()) {
          if (!/^\d*\.?\d{0,1}$/.test(value)) {
            return;
          }
        } else {
          // primary unit -> allow 3 decimals
          if (!/^\d*\.?\d{0,3}$/.test(value)) {
            return;
          }
        }
      } else {
        // allow only integer
        if (!/^\d*$/.test(value)) {
          return;
        }
      }
    }

    if (name === "lcmultiplayer") {
      const regex = /^$|^\d*\.?\d{0,10}$/;
      if (!regex.test(value)) {
        return;
      }
      const multiplier = parseFloat(value) || 0;
      const landing = finance.getFinalLandingCost(
        multiplier,
        finance.toSubunit(isProductData.finalLandingCost, "INR"),
      );
      // multiplier * (parseFloat(isProductData.finalLandingCost) || 0);
      const updatedData = {
        ...isProductData,
        lcmultiplayer: value,
        landingcost: finance.toCurrency(landing, "INR"),
      };

      localStorage.setItem("lastMultiplier", value);

      setProductData(updatedData);
      handleCalculate(updatedData);
      return;
    }

    if (name === "landingcost") {
      const updatedData = {
        ...isProductData,
        landingcost: inputValue,
        lcmultiplayer: "",
      };

      setProductData(updatedData);
      handleCalculate(updatedData);
      return;
    }

    if (name === "quantity") {
      const updatedData = {
        ...isProductData,
        quantity: inputValue,
      };

      setProductData(updatedData);

      //  ONLY update API quantity
      setApiData((prev) => ({
        ...prev,
        quantity: Number(inputValue) || 0,
      }));

      return; //  STOP here (no calculate)
    }
    const updatedData = {
      ...isProductData,
      [name]: inputValue,
    };
    setProductData(updatedData);
    handleCalculate(updatedData);
  };

  const handleRadioChange = (inputName) => {
    // setSelectedRadio(inputName);
    setProductData((prev) => ({
      ...prev,
      isLock: inputName,
    }));
  };

  const isValidDate = (date) => {
    const d = new Date(date);
    return !isNaN(d.getTime());
  };

  const handleUnitConversion = (unitName, type) => {
    if (unitName === selectedUnit) return;

    setSelectedUnit(unitName);
    if (uRLs.UNIT === "true") {
      let numericMrp = CurrencyConverter.toSubunit(
        baseRef.current.mrp || 0,
        "INR",
      );
      let numericSaleprice = CurrencyConverter.toSubunit(
        baseRef.current.saleprice || 0,
        "INR",
      );
      let numericBaseprice = CurrencyConverter.toSubunit(
        baseRef.current.baseprice || 0,
        "INR",
      );
      let numericTaxpercentage = parseInt(isProductData?.taxpercentage);
      let quanity = isProductData?.quantity || 0;
      let lock = isProductData?.isLock;
      if (type === "p") {
        const value = toPrimaryUnitPrice(
          numericMrp,
          numericSaleprice,
          numericBaseprice,
          numericTaxpercentage,
          quanity,
          lock,
          isProductData.unitConfig,
        );
        const primaryQuantity = toPrimaryQuantity(
          quanity,
          isProductData.unitConfig,
        );
        setProductData((prev) => ({
          ...prev,
          mrp: CurrencyConverter.toCurrency(isApiData.mrp, "INR"),
          saleprice: CurrencyConverter.toCurrency(isApiData.saleprice, "INR"),
          baseprice: CurrencyConverter.toCurrency(isApiData.baseprice, "INR"),
          taxamount: CurrencyConverter.toCurrency(
            value?.primaryUnitPrice?.taxAmount,
            "INR",
          ),
          discount: CurrencyConverter.toCurrency(
            value?.primaryUnitPrice?.discount,
            "INR",
          ),
          quantity: 0,
          // quantity: Number(value?.primaryUnitPrice?.quantity),
        }));
        baseRef.current = {
          mrp: isApiData.mrp / 100,
          saleprice: isApiData.saleprice / 100,
          baseprice: isApiData.baseprice / 100,
        };
        setApiData({
          ...isApiData,
          quantity: 0,
          // quantity:Number(primaryQuantity?.primaryQty),
        });
      } else if (type === "s") {
        const value = toSecondaryUnitPrice(
          Number(numericMrp),
          Number(numericSaleprice),
          Number(numericBaseprice),
          numericTaxpercentage,
          quanity,
          lock,
          isProductData.unitConfig,
        );
        const secondaryQuantity = toSecondaryQuantity(
          quanity,
          isProductData.unitConfig,
        );
        const primaryQuantity = toPrimaryQuantity(
          secondaryQuantity.secondaryQty,
          isProductData.unitConfig,
        );
        setProductData((prev) => ({
          ...prev,
          mrp: CurrencyConverter.toCurrency(
            value?.secondaryUnitPrice?.mrp,
            "INR",
          ),
          saleprice: CurrencyConverter.toCurrency(
            value?.secondaryUnitPrice?.salePrice,
            "INR",
          ),
          baseprice: CurrencyConverter.toCurrency(
            value?.secondaryUnitPrice?.basePrice,
            "INR",
          ),
          taxamount: CurrencyConverter.toCurrency(
            value?.secondaryUnitPrice?.taxAmount,
            "INR",
          ),
          discount: CurrencyConverter.toCurrency(
            value?.secondaryUnitPrice?.discount,
            "INR",
          ),
          quantity: 0,
          // quantity: Number(value?.secondaryUnitPrice?.quantity),
        }));
        baseRef.current = {
          mrp: value?.secondaryUnitPrice?.mrp / 100,
          saleprice: value?.secondaryUnitPrice?.salePrice / 100,
          baseprice: value?.secondaryUnitPrice?.basePrice / 100,
        };
        setApiData({
          ...isApiData,
          quantity: 0,
          // quantity:Number(secondaryQuantity?.secondaryQty),
        });
      }
    }
  };

  const onAdd = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const updatedData = {
      ...isProductData,
      mrp: isApiData?.mrp,
      saleprice: isApiData?.saleprice,
      baseprice: isApiData?.baseprice,
      quantity: isApiData?.quantity,
      manufacturedate: isValidDate(manufacturedate)
        ? new Date(manufacturedate).toISOString()
        : null,
      expiredate: isValidDate(expiredate)
        ? new Date(expiredate).toISOString()
        : null,
    };
    if (isUser.stype === "MAIN") {
      onStockAdd(updatedData, selectedProduct, resetForm, selectedUnit);
    } else {
      if (isProductData?.isStock) {
        // handleAddDirect(isProductData);
        showAlert("warning", "Product already instock");
      } else {
        onStockCreate(updatedData, selectedProduct, resetForm, selectedUnit);
      }
    }
    // resetForm();
  };

  const resetForm = () => {
    setProductData({
      mrp: 0,
      saleprice: 0,
      taxpercentage: 0,
      discount: 0,
      baseprice: 0,
      taxamount: 0,
      quantity: 0,
      landingcost: 0,
      isLock: "SALEPRICE",
    });
    setErrors("");
    searchRef.current?.focus();
    setselectedProduct(null);
    // setSelectedRadio("SALEPRICE");
    setEDate(null);
    setMDate(null);
  };

  const validateForm = () => {
    const errors = {};
    // if (!selectedProduct || !selectedProduct._id) {

    if (!selectedProduct) {
      errors.productid = Messages.ERROR.PRODUCTID_EMPTY;
    } else if (
      isProductData.saleprice === undefined ||
      isProductData.saleprice === null ||
      isProductData.saleprice === ""
    ) {
      errors.saleprice = Messages.ERROR.SALEPRICE_EMPTY;
      productSalepriceRef.current?.focus();
    } else if (
      isProductData.saleprice &&
      !/^\d*\.?\d{0,2}$/.test(isProductData.saleprice)
    ) {
      errors.saleprice = Messages.ERROR.INVALID_INPUT;
      productSalepriceRef.current?.focus();
    } else if (
      isProductData.taxpercentage === undefined ||
      isProductData.taxpercentage === null ||
      isProductData.taxpercentage === ""
    ) {
      errors.taxpercentage = Messages.ERROR.TAX_EMPTY;
      productTaxpercentageRef.current?.focus();
    } else if (
      isProductData.taxpercentage &&
      !/^[0-9]*$/.test(isProductData.taxpercentage)
    ) {
      errors.taxpercentage = Messages.ERROR.INVALID_INPUT;
      productTaxpercentageRef.current?.focus();
    } else if (
      isProductData.baseprice === undefined ||
      isProductData.baseprice === null ||
      isProductData.baseprice === ""
    ) {
      errors.baseprice = Messages.ERROR.BASEPRICE_EMPTY;
      productBasepriceRef.current?.focus();
    } else if (
      isProductData.baseprice &&
      !/^\d*\.?\d{0,2}$/.test(isProductData.baseprice)
    ) {
      errors.baseprice = Messages.ERROR.INVALID_INPUT;
      productBasepriceRef.current?.focus();
    } else if (
      isProductData.taxamount === undefined ||
      isProductData.taxamount === null ||
      isProductData.taxamount === ""
    ) {
      errors.taxamount = Messages.ERROR.TAXAMOUNT_EMPTY;
    } else if (
      isProductData.taxamount &&
      !/^\d*\.?\d{0,2}$/.test(isProductData.taxamount)
    ) {
      errors.taxamount = Messages.ERROR.INVALID_INPUT;
    } else if (
      isProductData.quantity === undefined ||
      isProductData.quantity === null ||
      isProductData.quantity === ""
    ) {
      errors.quantity = Messages.ERROR.STOCK_EMPTY;
      productMdateRef.current?.focus();
    } else if (
      isProductData.quantity &&
      !(uRLs.UNIT === "true"
        ? isSecondaryUnit()
          ? /^\d*\.?\d{0,1}$/.test(isProductData.quantity) // secondary
          : /^\d*\.?\d{0,3}$/.test(isProductData.quantity) // primary
        : /^\d+$/.test(isProductData.quantity))
    ) {
      errors.quantity = Messages.ERROR.INVALID_INPUT;
      productMdateRef.current?.focus();
    } else if (parseFloat(isProductData.quantity, 10) <= 0) {
      errors.quantity = Messages.ERROR.STOCK_INVALID;
      productMdateRef.current?.focus();
    }

    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors)[0];
      switch (firstErrorField) {
        case "saleprice":
          productSalepriceRef.current?.focus();
          break;
        case "taxpercentage":
          productTaxpercentageRef.current?.focus();
          break;
        case "baseprice":
          productBasepriceRef.current?.focus();
          break;
        case "productid":
          searchRef.current?.focus();
          break;
        default:
          break;
      }
    }
    return Object.keys(errors).length === 0;
  };

  const handleClose = async () => {
    resetForm();
  };

  const handleFieldFocus = (e) => {
    e.target.select?.();
    setOpenPicker(null);
  };

  const handleEnterKey = (e, fieldName, nextRef = null, isLast = false) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef === productMrpRef) {
        // const rect = nextRef.current.getBoundingClientRect();
        // setPopupMrpStyle({
        //   position: "absolute",
        //   top: `${rect.top + window.scrollY}px`,
        //   left: `${rect.left + window.scrollX}px`,
        //   width: `${rect.width}px`,
        //   zIndex: 10000,
        // });
        setPopupMrpStyle(getMrpPopupStyle(nextRef));
        setPopupMrpValue(isProductData.mrp);
        setShowMrpPopup(true);
      }
      if (isLast) {
        onAdd(e);
      } else {
        const nextInput =
          nextRef?.current?.input ||
          nextRef?.current?.flatpickr?.input ||
          nextRef?.current?.querySelector?.("input") ||
          nextRef?.current;

        if (nextInput && typeof nextInput.focus === "function") {
          nextInput.focus();
        } else {
          console.warn("Cannot focus nextRef:", nextRef);
        }
      }
    }
  };

  const getMrpPopupStyle = (inputRef) => {
    const scrollParent = inputRef.current.closest(".modal-body");
    if (!scrollParent) return {};
    return {
      position: "absolute",
      top: "208px",
      left: "16px",
      width: "130px",
      zIndex: 10000,
    };
  };

  useEffect(() => {
    if (onData) {
      handleSelectSuggestion(onData, finalLand);
    }
  }, [onData]);

  useEffect(() => {
    const savedMultiplier = localStorage.getItem("lastMultiplier");
    if (isProductData.lcmultiplayer) {
      const multiplier = parseFloat(savedMultiplier) || 0;
      const landing = finance.getFinalLandingCost(
        multiplier,
        finance.toSubunit(isProductData.finalLandingCost, "INR"),
      );

      const updatedData = {
        ...isProductData,
        lcmultiplayer: savedMultiplier,
        landingcost: finance.toCurrency(landing, "INR"),
      };

      setProductData(updatedData);
      handleCalculate(updatedData);
    }
  }, [selectedProduct]);

  useEffect(() => {
    return () => {
      localStorage.setItem("lastMultiplier", 1);
    };
  }, []);

  useEffect(() => {
    if (isUser.stype === "MAIN") {
      productMrpRef.current?.focus();
    } else {
      productMdateRef.current?.focus();
    }
  }, [selectedProduct]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        mfgDateWrapperRef.current &&
        !mfgDateWrapperRef.current.contains(e.target)
      ) {
        setOpenMfgDate(false);
      }
      if (
        expDateWrapperRef.current &&
        !expDateWrapperRef.current.contains(e.target)
      ) {
        setOpenExpDate(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setSelectedUnit(isProductData?.unitConfig?.primaryUnitCode);
  }, [isProductData?.unitConfig]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const stopEventPropagation = (e) => e.stopPropagation();
  return (
    <>
      <div className="modal-overlay">
        <div className="modal-backdrop show"></div>
        <div
          className="modal show"
          id="CustomerModal"
          tabIndex="-1"
          aria-modal="true"
          role="dialog"
          // onClick={handleClose}
          style={{ display: "block" }}
        >
          <div
            className="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
            onClick={stopEventPropagation}
          >
            <div className="modal-content" style={{ position: "relative" }}>
              <div className="modal-header">
                <h6 className="modal-title">Add Stock</h6>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onclose}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div
                className="modal-body bg-light"
                style={{ overflowX: "hidden" }}
              >
                <div className="card ">
                  <div className="card-body">
                    <div className="row g-3">
                      <div className="col-lg-12 mt-3">
                        <div className="card shadow-none border-blue mb-0">
                          <div className="card-header bg-light-blue p-2">
                            <div className="mb-0">Product info</div>
                          </div>
                          {selectedProduct ? (
                            <>
                              {/* <p className="mb-1">
                              Title:{" "}
                              <span className="fw-600">
                                {selectedProduct?.title}
                              </span>
                            </p>
                            <p className="mb-1">
                              HSN :{" "}
                              {selectedProduct?.hsnsac ? (
                                <span className="fw-600">
                                  {selectedProduct?.hsnsac}
                                </span>
                              ) : (
                                <>-</>
                              )}
                            </p> */}
                              {/* <p className="mb-1">
                              SalePrice:{" "}
                              <span className="fw-600">
                                ₹{selectedProduct.saleprice || 0}{" "}
                              </span>
                            </p> */}
                              <div className="card-body p-2">
                                <div className="d-flex fs-13">
                                  <div
                                    className="mb-1 d-flex  gap-2"
                                    style={{ flexBasis: "100%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      Title:
                                    </span>
                                    {selectedProduct?.title ? (
                                      <span className="fw-600 ">
                                        {selectedProduct?.title}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                </div>
                                <div className="d-flex fs-13">
                                  <div
                                    className="mb-1 d-flex align-items-center gap-2"
                                    style={{ flexBasis: "50%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      SKU Code:
                                    </span>
                                    {selectedProduct?.code ? (
                                      <span className="badge rounded-pill bg-label-navy">
                                        {selectedProduct?.code}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                  <div
                                    className="mb-1 d-flex align-items-center gap-2"
                                    style={{ flexBasis: "50%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      HSN:
                                    </span>
                                    {selectedProduct?.hsnsac ? (
                                      <span className="badge rounded-pill bg-label-retro">
                                        {selectedProduct.hsnsac}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                </div>
                                <div className="d-flex fs-13">
                                  <div
                                    className="mb-1 d-flex align-items-center gap-2"
                                    style={{ flexBasis: "50%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      Brand:
                                    </span>
                                    {selectedProduct?.brandId ? (
                                      <span className="badge bg-label-kids">
                                        {selectedProduct?.brandId}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                  <div
                                    className="mb-1 d-flex align-items-center gap-2"
                                    style={{ flexBasis: "50%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      Stock Left:
                                    </span>
                                    {selectedProduct?.totalStockLeft ? (
                                      <span className="badge bg-label-space">
                                        {selectedProduct?.totalStockLeft}&nbsp;
                                        {defaultConversion?.unitCode
                                          ? defaultConversion?.unitCode
                                          : ""}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                </div>
                                <div className="d-flex fs-13">
                                  <div
                                    className="mb-1 d-flex align-items-center gap-2"
                                    style={{ flexBasis: "50%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      Note:
                                    </span>
                                    {selectedProduct?.note ? (
                                      <span className="badge bg-label-sun">
                                        {selectedProduct?.note}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                  {uRLs.UNIT === "true" && (
                                    <div
                                      className="mb-2 d-flex align-items-center gap-2"
                                      style={{ flexBasis: "50%" }}
                                    >
                                      <span className="fw-semibold text-muted">
                                        Unit:
                                      </span>
                                      {defaultConversion?.unitName ? (
                                        <span className="badge rounded-pill btn-unit">
                                          {defaultConversion?.unitName} (
                                          {defaultConversion.unitCode})
                                        </span>
                                      ) : (
                                        "-"
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <p className="mb-1 text-muted">
                              No products has been selected
                            </p>
                          )}
                        </div>
                      </div>
                      {/* {selectedProduct ? ( */}
                      <>
                        <div className="col-12 border-top ">
                          <div className="fw-600 mt-2">
                            Amount{" "}
                            {selectedUnit ? (
                              <span className="">(Per {selectedUnit})</span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <label htmlFor="mrp" className="form-label">
                            {" "}
                            MRP{" "}
                          </label>
                          {showMrpPopup && (
                            <input
                              type="text"
                              ref={popupMrpInputRef}
                              value={popupMrpValue}
                              onChange={(e) => {
                                const val = e.target.value;

                                // Regex: only digits, optional one dot, up to 2 decimals
                                const regex = /^\d+(\.\d{0,2})?$/;

                                if (val === "" || regex.test(val)) {
                                  setPopupMrpValue(val);
                                  setProductData((prev) => ({
                                    ...prev,
                                    mrp: val,
                                  }));
                                  handleCalculate({
                                    ...isProductData,
                                    mrp: val,
                                  });
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  setShowMrpPopup(false);
                                  setTimeout(() => {
                                    productSalepriceRef?.current?.focus();
                                  }, 0);
                                }
                              }}
                              onBlur={() => setShowMrpPopup(false)}
                              autoFocus
                              onFocus={handleFieldFocus}
                              // style={popupMrpStyle}
                              className="form-control"
                            />
                          )}
                          {!showMrpPopup && (
                            <input
                              type="text"
                              className="form-control"
                              name="mrp"
                              autoComplete="off"
                              ref={productMrpRef}
                              value={isProductData.mrp}
                              onFocus={handleFieldFocus}
                              onChange={handleChange}
                              disabled={
                                isUser.stype !== "MAIN" &&
                                isProductData?.isStock
                              }
                              onKeyDown={(e) =>
                                handleEnterKey(e, "mrp", productSalepriceRef)
                              }
                              onClick={() => {
                                // const rect =
                                //   productMrpRef.current.getBoundingClientRect();
                                setPopupMrpStyle(
                                  getMrpPopupStyle(productMrpRef),
                                );
                                setPopupMrpValue(isProductData.mrp);
                                setShowMrpPopup(true);
                              }}
                            />
                          )}
                          {error.mrp && (
                            <div className="invalid-feedback">{error.mrp}</div>
                          )}
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="saleprice" className="form-label">
                            Sale Price <span className="text-danger">*</span>
                          </label>
                          <div className="input-container position-relative">
                            <input
                              type="text"
                              name="saleprice"
                              autoComplete="off"
                              ref={productSalepriceRef}
                              value={isProductData.saleprice}
                              className="form-control"
                              onFocus={handleFieldFocus}
                              onClick={() => handleRadioChange("SALEPRICE")}
                              style={{ paddingLeft: "30px" }}
                              disabled={
                                isUser.stype !== "MAIN" &&
                                isProductData?.isStock
                              }
                              onChange={handleChange}
                              onKeyDown={(e) =>
                                handleEnterKey(
                                  e,
                                  "saleprice",
                                  productTaxpercentageRef,
                                )
                              }
                            />
                            <input
                              type="radio"
                              name="priceLock"
                              checked={isProductData?.isLock === "SALEPRICE"}
                              onChange={() => handleRadioChange("SALEPRICE")}
                              className="position-absolute"
                              style={{
                                top: "50%",
                                left: "10px",
                                transform: "translateY(-50%)",
                                zIndex: 2,
                              }}
                            />
                          </div>
                          {error.saleprice && (
                            <div className="invalid-feedback">
                              {error.saleprice}
                            </div>
                          )}
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="taxpercentage" className="form-label">
                            Tax(%) <span className="text-danger">*</span>
                          </label>
                          <select
                            name="taxpercentage"
                            className="form-control"
                            ref={productTaxpercentageRef}
                            value={isProductData.taxpercentage}
                            disabled={
                              isUser.stype !== "MAIN" && isProductData?.isStock
                            }
                            onChange={handleChange}
                            onKeyDown={(e) =>
                              handleEnterKey(
                                e,
                                "taxpercentage",
                                productBasepriceRef,
                              )
                            }
                          >
                            <option value="0">0</option>
                            <option value="5">5</option>
                            <option value="12">12</option>
                            <option value="18">18</option>
                            <option value="24">24</option>
                          </select>
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="discount" className="form-label">
                            Discount
                          </label>
                          <input
                            readOnly=""
                            type="text"
                            name="discount"
                            autoComplete="off"
                            value={isProductData.discount}
                            className="form-control"
                            disabled
                          />
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="baseprice" className="form-label">
                            Base Price
                          </label>
                          <div className="input-container position-relative">
                            <input
                              type="text"
                              name="baseprice"
                              autoComplete="off"
                              ref={productBasepriceRef}
                              onClick={() => handleRadioChange("BASEPRICE")}
                              onChange={handleChange}
                              value={isProductData.baseprice}
                              onFocus={handleFieldFocus}
                              disabled={
                                isUser.stype !== "MAIN" &&
                                isProductData?.isStock
                              }
                              className="form-control"
                              style={{ paddingLeft: "30px" }}
                              onKeyDown={(e) =>
                                handleEnterKey(
                                  e,
                                  "baseprice",
                                  manufacturedateRefs,
                                )
                              }
                            />
                            <input
                              type="radio"
                              name="priceLock"
                              checked={isProductData?.isLock === "BASEPRICE"}
                              onChange={() => handleRadioChange("BASEPRICE")}
                              className="position-absolute"
                              style={{
                                top: "50%",
                                left: "10px",
                                transform: "translateY(-50%)",
                                zIndex: 2,
                              }}
                            />
                          </div>
                          {error.baseprice && (
                            <div className="invalid-feedback">
                              {error.baseprice}
                            </div>
                          )}
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="taxamount" className="form-label">
                            Tax Amount
                          </label>
                          <input
                            readOnly=""
                            type="text"
                            name="taxamount"
                            autoComplete="off"
                            className="form-control"
                            value={isProductData.taxamount}
                            disabled
                          />
                        </div>
                        <div className="col-12 border-top"></div>
                        <>
                          {viewOption(
                            "stockSettings",
                            "isManufactureAndExpiryDates",
                          ) && (
                            <>
                              <div className="col-lg-4" ref={mfgDateWrapperRef}>
                                <label
                                  htmlFor="manufacturedate"
                                  className="form-label"
                                >
                                  Manufacture Date
                                </label>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <ClickAwayListener
                                    disableReactTree
                                    onClickAway={() => setOpenPicker(null)}
                                  >
                                    <DatePicker
                                      open={openPicker === "mfg"}
                                      onOpen={() => setOpenPicker("mfg")}
                                      onClose={() => setOpenPicker(null)}
                                      disableOpenPicker // ❌ disables icon click
                                      value={
                                        manufacturedate
                                          ? dayjs(manufacturedate)
                                          : null
                                      }
                                      maxDate={dayjs(iso)}
                                      format="DD MMM YYYY"
                                      disabled={
                                        isUser.stype !== "MAIN" &&
                                        isProductData?.isStock
                                      }
                                      onChange={(newValue) => {
                                        if (!newValue) return;

                                        const isoDate = newValue
                                          .toDate()
                                          .toISOString();
                                        const indiaTime =
                                          DateConverter.convertToTimeZone(
                                            isoDate,
                                            isUser?.timezone,
                                          );

                                        setMDate(indiaTime);
                                        setExpireMinDate(indiaTime);
                                        setOpenPicker(null);
                                      }}
                                      slotProps={{
                                        textField: {
                                          inputRef: manufacturedateRefs,
                                          className: "form-control",
                                          size: "small",
                                          inputProps: { readOnly: true },
                                          onClick: () => setOpenPicker("mfg"),
                                          // onKeyDown: (e) =>
                                          //   handleEnterKey(
                                          //     e,
                                          //     "manufacturedate",
                                          //     expiredateRefs
                                          //   ),
                                          onKeyDown: (e) => {
                                            if (e.key === "Enter") {
                                              handleEnterKey(
                                                e,
                                                "manufacturedate",
                                                expiredateRefs,
                                              );
                                            } else {
                                              e.preventDefault();
                                            }
                                          },

                                          sx: {
                                            "& .MuiInputBase-input": {
                                              cursor: "pointer",
                                            },
                                          },
                                        },
                                        openPickerButton: {
                                          sx: { display: "none" }, //  hide icon completely
                                        },
                                      }}
                                    />
                                  </ClickAwayListener>
                                </LocalizationProvider>
                              </div>

                              <div className="col-lg-4" ref={expDateWrapperRef}>
                                <label
                                  htmlFor="expiredate"
                                  className="form-label"
                                  style={{ marginBottom: "29px" }}
                                >
                                  Expire Date
                                </label>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <ClickAwayListener
                                    disableReactTree
                                    onClickAway={() => setOpenPicker(null)}
                                  >
                                    <DatePicker
                                      open={openPicker === "exp"}
                                      onOpen={() => setOpenPicker("exp")}
                                      onClose={() => setOpenPicker(null)}
                                      disableOpenPicker
                                      value={
                                        expiredate ? dayjs(expiredate) : null
                                      }
                                      minDate={
                                        expireMinDate
                                          ? dayjs(expireMinDate)
                                          : undefined
                                      }
                                      format="DD MMM YYYY"
                                      disabled={
                                        isUser.stype !== "MAIN" &&
                                        isProductData?.isStock
                                      }
                                      onChange={(newValue) => {
                                        if (!newValue) return;

                                        const isoDate = newValue
                                          .toDate()
                                          .toISOString();
                                        const indiaTime =
                                          DateConverter.convertToTimeZone(
                                            isoDate,
                                            isUser?.timezone,
                                          );

                                        setEDate(indiaTime);
                                        setOpenPicker(null);
                                      }}
                                      slotProps={{
                                        textField: {
                                          inputRef: expiredateRefs,
                                          className: "form-control",
                                          size: "small",
                                          onClick: () => setOpenPicker("exp"),
                                          inputProps: { readOnly: true },
                                          onKeyDown: (e) => {
                                            if (e.key === "Enter") {
                                              handleEnterKey(
                                                e,
                                                "expiredate",
                                                productMdateRef,
                                              );
                                            } else {
                                              e.preventDefault();
                                            }
                                          },
                                          sx: {
                                            "& .MuiInputBase-input": {
                                              cursor: "pointer",
                                            },
                                          },
                                        },
                                        openPickerButton: {
                                          sx: { display: "none" },
                                        },
                                      }}
                                    />
                                  </ClickAwayListener>
                                </LocalizationProvider>
                              </div>
                            </>
                          )}

                          <div className="col-lg-4">
                            <label
                              htmlFor="quantity"
                              className="form-label"
                              style={{ marginBottom: "29px" }}
                            >
                              Stock <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="quantity"
                                autoComplete="off"
                                ref={productMdateRef}
                                value={isProductData.quantity}
                                onFocus={(e) => e.target.select()}
                                onChange={handleChange}
                                onKeyDown={(e) => {
                                  handleEnterKey(e, "quantity", null, true);
                                }}
                              />
                              {uRLs.UNIT === "true" &&
                                isProductData?.unitConfig && (
                                  <div
                                    className="d-flex text-start position-relative"
                                    ref={dropdownRef}
                                  >
                                    <button
                                      className="btn btn-unit shadow-none  border-end-0 rounded-end-0 rounded-start-0  dropdown-toggle-split"
                                      id="printreceiptbtn"
                                      // data-bs-toggle="dropdown"
                                      onClick={() =>
                                        setDropdownOpen((prev) => !prev)
                                      }
                                    >
                                      {selectedUnit}
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-unit shadow-none  dropdown-toggle dropdown-toggle-split rounded-start-0 border-start-0"
                                      // data-bs-toggle="dropdown"
                                      // aria-expanded="false"
                                      aria-expanded={dropdownOpen}
                                      onClick={() =>
                                        setDropdownOpen((prev) => !prev)
                                      }
                                    />
                                    {dropdownOpen && (
                                      <ul
                                        className="dropdown-menu show"
                                        style={{
                                          position: "absolute",
                                          top: "100%",
                                          right: 0,
                                          zIndex: 1050,
                                        }}
                                      >
                                        <li>
                                          <button
                                            type="button"
                                            className={`dropdown-item ${
                                              selectedUnit ===
                                              unitData?.primaryUnitCode
                                                ? "active"
                                                : ""
                                            }`}
                                            onClick={() => {
                                              productMdateRef.current.focus();
                                              handleUnitConversion(
                                                unitData?.primaryUnitCode,
                                                "p",
                                              );
                                              setDropdownOpen(false);
                                            }}
                                          >
                                            {unitData?.primaryUnitName} (
                                            {unitData?.primaryUnitCode})
                                          </button>
                                        </li>
                                        {unitData?.secondaryUnitCode && (
                                          <li>
                                            <button
                                              type="button"
                                              className={`dropdown-item ${
                                                selectedUnit ===
                                                unitData?.secondaryUnitCode
                                                  ? "active"
                                                  : ""
                                              }`}
                                              onClick={() => {
                                                productMdateRef.current.focus();
                                                handleUnitConversion(
                                                  unitData?.secondaryUnitCode,
                                                  "s",
                                                );
                                                setDropdownOpen(false);
                                              }}
                                            >
                                              {unitData?.secondaryUnitName} (
                                              {unitData?.secondaryUnitCode})
                                            </button>
                                          </li>
                                        )}
                                      </ul>
                                    )}
                                  </div>
                                )}
                            </div>
                            {error.quantity && (
                              <div className="invalid-feedback">
                                {error.quantity}
                              </div>
                            )}
                          </div>
                        </>
                      </>
                      {/* ) : (
                      ""
                    )} */}
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="list-group-item py-2">
                          <div className="d-flex align-items-center">
                            <span className="fw-600 ms-2">Landing Cost</span>
                            <div className="ms-auto custom-toggle-wrapper">
                              <label className="custom-toggle cursor-pointer">
                                <input
                                  type="checkbox"
                                  id="stockToggle"
                                  checked={toggles["landingcost"]}
                                  onChange={() =>
                                    handleToggleChange("landingcost")
                                  }
                                  disabled={loading["stock"]}
                                />
                                <span className="slider">
                                  {loading["landingcost"] ? (
                                    <span
                                      className={`spinner-inside ${
                                        toggles["landingcost"]
                                          ? "spinner-right"
                                          : ""
                                      }`}
                                    />
                                  ) : (
                                    <>
                                      {toggles["landingcost"] ? (
                                        <span className="label-on ms-0-1"></span>
                                      ) : (
                                        <span className="label-off ms-3"></span>
                                      )}
                                    </>
                                  )}
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`toggle-section ${
                            toggles["landingcost"]
                              ? "show-section"
                              : "hide-section"
                          }`}
                        >
                          <div className="row">
                            {/* <div className="col-12 mb-2 fs-6">
                    <span className="fw-semibold">Landing Cost</span>
                  </div> */}

                            {/* Labels Row */}
                            {viewOption(
                              "stockSettings",
                              "isLandingCostMultiplier",
                            ) && (
                              <>
                                <div className="col-3 d-flex align-items-center justify-content-center">
                                  <label
                                    htmlFor="lcmultiplayer"
                                    className="form-label text-expense"
                                  >
                                    Multiplier
                                    <span className="tooltip-container ms-1">
                                      <span className="tooltip-icon">?</span>
                                      <span className="tooltip-text">
                                        When adding stock, you can enter a
                                        multiplier in the extra box to
                                        recalculate the landing cost. For
                                        example, 1.5 × ₹50 = ₹75. If this
                                        feature is turned off, the system will
                                        use the manual value you enter.
                                      </span>
                                    </span>
                                  </label>
                                </div>
                                <div className="col-1 text-center"></div>
                                <div className="col-3 d-flex align-items-center justify-content-center">
                                  <label
                                    htmlFor="finallandingcost"
                                    className="form-label text-brown"
                                  >
                                    Landing Cost
                                    <span className="tooltip-container ms-1">
                                      <span className="tooltip-icon">?</span>
                                      <span className="tooltip-text">
                                        Total cost to bring the product to your
                                        inventory, including purchase price and
                                        taxes.
                                      </span>
                                    </span>
                                  </label>
                                </div>
                                <div className="col-1 text-center"></div>
                              </>
                            )}
                            <div className="col-4">
                              <label
                                htmlFor="landingcost"
                                className="form-label bg-dark-text"
                              >
                                Final Landing Cost{" "}
                                <small>(Per Unit) (Optional)</small>
                                <span className="tooltip-container ms-1">
                                  <span className="tooltip-icon">?</span>
                                  <span className="tooltip-text">
                                    Total cost to bring the product to your
                                    inventory, including purchase price and
                                    taxes.
                                  </span>
                                </span>
                              </label>
                            </div>

                            {/* Inputs Row */}
                            {viewOption(
                              "stockSettings",
                              "isLandingCostMultiplier",
                            ) && (
                              <>
                                <div className="col-3">
                                  <input
                                    type="text"
                                    name="lcmultiplayer"
                                    autoComplete="off"
                                    ref={productMultiCostRef}
                                    value={isProductData?.lcmultiplayer}
                                    className="form-control"
                                    onFocus={(e) => e.target.select()}
                                    onChange={handleChange}
                                    onKeyDown={(e) =>
                                      handleEnterKey(
                                        e,
                                        "landingcost",
                                        productLandingCostRef,
                                      )
                                    }
                                  />
                                </div>

                                <div className="col-1 d-flex align-items-center justify-content-center fs-4">
                                  <i className="bx text-muted">⨯</i>
                                </div>

                                <div className="col-3 d-flex align-items-center justify-content-center">
                                  <span className="badge bg-label-wood fs-6">
                                    ₹{isProductData?.finalLandingCost}
                                  </span>
                                </div>

                                <div className="col-1 d-flex align-items-center justify-content-center fs-4">
                                 
                                  <LineDoubleIcon iClass={"text-muted"}/>
                                </div>
                              </>
                            )}
                            <div className="col-4">
                              <input
                                type="text"
                                name="landingcost"
                                autoComplete="off"
                                ref={productLandingCostRef}
                                value={isProductData?.landingcost}
                                className="form-control"
                                onFocus={(e) => e.target.select()}
                                onChange={handleChange}
                                onKeyDown={(e) =>
                                  handleEnterKey(e, "landingcost", null, true)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer d-block">
                <button
                  type="button"
                  className="btn btn-outline-secondary text-left"
                  onClick={onclose}
                >
                  <XIcon/> Cancel
                </button>
                {isBtnLoading ? (
                  <button className="btn btn-teal pb-0 text-right" disabled>
                    <CircularProgress size={22} className="text-white" />
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-teal text-right"
                    onClick={onAdd}
                    ref={addStockBtnRef}
                  >
                    <StockAddIcon/> Add Stock
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {showMrpPopup && (
        <input
          type="text"
          ref={popupMrpInputRef}
          value={popupMrpValue}
          onChange={(e) => {
            const val = e.target.value;
            setPopupMrpValue(val);
            setProductData((prev) => ({ ...prev, mrp: val }));
            handleCalculate({ ...isProductData, mrp: val });
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setShowMrpPopup(false);
              setTimeout(() => {
                productSalepriceRef?.current?.focus();
              }, 0);
            }
          }}
          onBlur={() => setShowMrpPopup(false)}
          autoFocus
          onFocus={(e) => e.target.select()}
          style={popupMrpStyle}
          className="form-control position-absolute"
        />
      )} */}
    </>
  );
};

export default AddStockModel;
